export const dateFormatter = ({ locale = 'en-US', timeZone }: { locale?: string; timeZone?: string }) =>
  new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone,
  });
